import React from "react";

type TableRowData = {
  key: string;
  value: React.ReactNode; // この型はテキスト、数値、React要素などを含むことができる
}

type TableProps = {
  thList: string[];
  tdList: TableRowData[][];
}

export const Table: React.FC<TableProps> = ({thList, tdList}) => {
  return (
    <div className="table-scroll">
      <div className="contact-table">
        <ul className="contact-box__th contact-box__list contact-box__list--02">
          {thList && thList.map((th: string) => (
            <li className="contact-box__list-item">{th}</li>
          ))}
        </ul>
        {tdList.map((row, rowIndex) => (
          <ul key={rowIndex} className="contact-box__td contact-box__list contact-box__list--02">
            {row.map((cell, cellIndex) => (
              <li key={cellIndex} className="contact-box__list-item">{cell.value}</li>
            ))}
          </ul>
        ))}
      </div>
    </div>
  )
}